export const TEXT_FIELD_ID = 1
export const NUMERIC_ID = 2
export const DROPDOWN_ID = 3
export const RADIO_ID = 4
export const CHECKBOX_ID = 5
export const TAB_ID = 6
export const ACCORDIAN_ID = 7
export const TEXT_AREA_ID = 8
export const DATE_ID = 9
export const ATTACHMENT_ID = 10
export const DIGITAL_TOGGLE = 11
export const AUTO_COMPLETE_ID = 12
export const MULTI_SELECT_DROPDOWN = 13
export const MULTI_SELECT_CHECKBOX = 14
export const COMPLEX = 15
export const DROP_DOWN_TEXT_ID = 19
export const COUNTRY_SELECT_ID = 16
export const STATE_SELECT_ID = 17
export const CITY_SELECT_ID = 18
export const COUNTRY_ID = 7
export const STATE_ID = 8
export const CITY_ID = 9

// select place
export const COUNTRY = 'country'
export const STATE = 'state'
export const CITY = 'city'

// Key name
export const ENTER = 'Enter'

// BoardComposition

export const INACTIVE = 2
